<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM9 5V7H11V5H9ZM11 14C11 14.5 10.6 15 10 15C9.4 15 9 14.5 9 14V10C9 9.4 9.4 9 10 9C10.6 9 11 9.4 11 10V14ZM2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10Z" fill="white"></path>
</template>

<script>
    export default {
        name: 'icon-info'
    }
</script>